import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(85vh - 50px); // Subtraindo o padding do modal
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 8px; // Espaço para a scrollbar
  margin-right: -8px; // Compensar o padding para alinhamento
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const FixedFooter = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const AvatarContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const ProfileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TextCotainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Title = styled.span`
  font-weight: 700;
  font-size: 20px;
`;

export const Text = styled.span`
  
`;

export const Subtitle = styled.span`
  font-size: 10px;

  white-space: nowrap;      
  overflow: hidden;         
  text-overflow: ellipsis;  
`;

export const PremiacaoInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
`;

export const PremiacaoImagem = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ValorContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ExtratoContainer = styled.div`
  margin-bottom: 20px;
`;

export const ExtratoHeader = styled.div`
  margin-bottom: 16px;
`;

export const ExtratoTitle = styled.h3`
  font-weight: 700;
  font-size: 16px;
  color: #2c3e50;
  margin: 0 0 6px 0;
  line-height: 1.3;
`;

export const ExtratoDescription = styled.p`
  font-size: 12px;
  color: #7f8c8d;
  margin: 0;
  line-height: 1.4;
`;

export const ExtratoList = styled.div`

`;

export const ExtratoItem = styled.div<{ isLast?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  margin-bottom: ${props => props.isLast ? '0' : '8px'};
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  
  &:hover {
    background-color: #f8f9fa;
    border-color: #e0e0e0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }
`;

export const ExtratoItemImage = styled.div`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ExtratoItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const ExtratoItemTitle = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: #2c3e50;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ExtratoMetaInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ExtratoItemValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  min-width: 80px;
`;

export const ExtratoPoints = styled.span<{ isPositive: boolean }>`
  color: ${props => props.isPositive ? '#27ae60' : '#e74c3c'};
  font-weight: 700;
  font-size: 18px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
`;

export const ExtratoPointsLabel = styled.span`
  font-size: 11px;
  color: #95a5a6;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1;
`;

export const ExtratoPointsRow = styled.div`
  display: flex;
  align-items: center;
    gap: 10px;

  line-height: 1;
`;

export const DownloadButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3498db;
  transition: all 0.2s ease;
  line-height: 1;

  &:hover:not(:disabled) {
    color: #2980b9;
    transform: scale(1.1);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  &:disabled {
    color: #bdc3c7;
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const ExtratoDate = styled.span`
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 400;
`;

export const ExtratoQuantidade = styled.span`
  font-size: 11px;
  color: #95a5a6;
  background-color: #ecf0f1;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
`;

export const ExtratoStatusTag = styled.span<{ statusId: number }>`
  font-size: 10px;
  color: #fff;
  background-color: ${props => {
    switch (props.statusId) {
      case 1: // Solicitado
        return '#3498db';
      case 2: // Aprovado
        return '#27ae60';
      case 3: // Não Aprovada
        return '#e74c3c';
      case 4: // Pago/Entregue
        return '#16a085';
      case 5: // Em Espera
        return '#f39c12';
      case 6: // Cancelado
        return '#95a5a6';
      case 7: // Lote Alocado
        return '#9b59b6';
      case 8: // Erro no Pagamento
        return '#c0392b';
      default:
        return '#7f8c8d';
    }
  }};
  padding: 3px 8px;
  border-radius: 4px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
`;

// Historico Styles
export const HistoricoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HistoricoItem = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  
  &:hover {
    border-color: #d0d0d0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }
`;

export const HistoricoItemContent = styled.div`
  padding: 12px;
`;

export const HistoricoItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
`;

export const HistoricoItemTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #2c3e50;
`;

export const HistoricoItemBadge = styled.span`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(118, 75, 162, 0.3);
`;

export const HistoricoItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const HistoricoDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
`;

export const HistoricoDetailLabel = styled.span`
  font-size: 13px;
  color: #7f8c8d;
  font-weight: 500;
`;

export const HistoricoDetailValue = styled.span<{ isHighlight?: boolean }>`
  font-size: 13px;
  color: ${props => props.isHighlight ? '#27ae60' : '#2c3e50'};
  font-weight: ${props => props.isHighlight ? '700' : '600'};
  ${props => props.isHighlight && `
    font-size: 14px;
  `}
`;

export const UserInfoHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const ExtratoToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: transparent;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #f5f5f5;
    border-color: #d0d0d0;
  }
  
  svg {
    transition: transform 0.2s ease;
  }
  
  &[data-expanded="true"] svg {
    transform: rotate(90deg);
  }
`;

// Value summary rows with subtle color coding (no layout changes)
export const ValueInfo = styled(PremiacaoInfo)`
  &[data-type="original"] span:last-child {
    color: #455A64; /* blue-grey for base value */
    font-weight: 500;
  }
  &[data-type="tax"] span:last-child {
    color: #E65100; /* deep orange for tax */
    font-weight: 600;
  }
  &[data-type="total"] span:last-child {
    color: #2E7D32; /* green for total */
    font-weight: 700;
  }
  &[data-type="total"] {
    border-top: 1px solid #e0e0e0;
    padding-top: 6px;
    margin-top: 2px;
  }
`;

// Resumo Styles
export const ResumoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 12px;
  margin-bottom: 16px;
  
  & > *:nth-child(-n+4) {
    grid-column: span 3;
  }
  
  & > *:nth-child(5) {
    grid-column: 2 / span 3;
  }
  
  & > *:nth-child(6) {
    grid-column: 5 / span 4;
  }
  
  & > *:nth-child(7) {
    grid-column: 9 / span 3;
  }
`;

export const ResumoCard = styled.div`
  background-color: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  gap: 12px;
  align-items: center;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  
  &:hover {
    border-color: #d0d0d0;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }
`;

export const ResumoCardIcon = styled.div`
  font-size: 28px;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  border-radius: 8px;
`;

export const ResumoCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const ResumoCardLabel = styled.span`
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 500;
  line-height: 1.2;
`;

export const ResumoCardValue = styled.span<{ isHighlight?: boolean }>`
  font-size: 18px;
  font-weight: 700;
  color: ${props => props.isHighlight ? '#27ae60' : '#2c3e50'};
  line-height: 1;
  font-variant-numeric: tabular-nums;
`;

export const ResumoFooter = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 8px;
`;

// Pedido Styles
export const PedidoCard = styled.div`
  background-color: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;

export const PedidoImageContainer = styled.div`
  width: 100%;
  height: 160px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(to top, rgba(0,0,0,0.1), transparent);
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const PedidoContent = styled.div`
  padding: 16px;
`;

export const PedidoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f0f0;
`;

export const PedidoTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1.3;
  flex: 1;
`;

export const PedidoDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PedidoDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
`;

export const PedidoDetailLabel = styled.span`
  font-size: 13px;
  color: #7f8c8d;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const PedidoDetailValue = styled.span<{ isTax?: boolean }>`
  font-size: 14px;
  color: ${props => props.isTax ? '#e65100' : '#2c3e50'};
  font-weight: 600;
  font-variant-numeric: tabular-nums;
`;

export const PedidoDetailValueTotal = styled.span`
  font-size: 18px;
  color: #2e7d32;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
`;

export const PedidoDivider = styled.div`
  height: 1px;
  background: linear-gradient(to right, transparent, #e8e8e8, transparent);
  margin: 4px 0;
`;

// Status Selection Styles
export const StatusSection = styled.div`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StatusHeader = styled.div`
  margin-bottom: 8px;
`;

export const StatusTitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: #2c3e50;
  font-weight: 500;
`;

export const StatusButtonGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

type StatusButtonProps = {
  isSelected: boolean;
  statusType: 'warning' | 'positive' | 'danger' | 'neutral';
};

export const StatusButton = styled.button<StatusButtonProps>`
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid;
  background-color: ${props => {
    if (props.isSelected) {
      switch (props.statusType) {
        case 'warning': return '#FFF3E0';
        case 'positive': return '#E8F5E9';
        case 'danger': return '#FFEBEE';
        default: return '#F5F5F5';
      }
    }
    return '#ffffff';
  }};
  
  border-color: ${props => {
    if (props.isSelected) {
      switch (props.statusType) {
        case 'warning': return '#F07300';
        case 'positive': return '#008826';
        case 'danger': return '#D32F2F';
        default: return '#9E9E9E';
      }
    }
    return '#e0e0e0';
  }};
  
  color: ${props => {
    if (props.isSelected) {
      switch (props.statusType) {
        case 'warning': return '#E65100';
        case 'positive': return '#2E7D32';
        case 'danger': return '#C62828';
        default: return '#424242';
      }
    }
    return '#616161';
  }};
  
  &:hover {
    border-color: ${props => {
    switch (props.statusType) {
      case 'warning': return '#F07300';
      case 'positive': return '#008826';
      case 'danger': return '#D32F2F';
      default: return '#757575';
    }
  }};
    background-color: ${props => {
    switch (props.statusType) {
      case 'warning': return '#FFF8F0';
      case 'positive': return '#F1F8F1';
      case 'danger': return '#FFF5F5';
      default: return '#FAFAFA';
    }
  }};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const StatusMessage = styled.p`
  margin: 0;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 13px;
  color: #757575;
  text-align: center;
  font-style: italic;
`;

// Última Operação Styles
export const UltimaOperacaoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const UltimaOperacaoTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
`;

export const UltimaOperacaoCard = styled.div`
  background-color: #f8f9fa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const UltimaOperacaoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const UltimaOperacaoLabel = styled.span`
  font-size: 13px;
  color: #7f8c8d;
  font-weight: 500;
`;

export const UltimaOperacaoValue = styled.span`
  font-size: 13px;
  color: #2c3e50;
  font-weight: 600;
`;

// Motivo Section Styles
export const MotivoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0;
`;

export const MotivoLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
`;

export const MotivoTextarea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  color: #2c3e50;
  resize: vertical;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #D32F2F;
    background-color: #FFF5F5;
  }
  
  &::placeholder {
    color: #bdc3c7;
  }
`;